import circularBorder from '@/assets/icons/circular-border.svg'
import ourServicesBg from '@/assets/images/home/our-services.jpg'
import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'

const services: ServiceProps[] = [
  {
    title: 'Home Interior',
    description:
      'Designing personalized spaces that reflect your lifestyle, combining comfort with modern aesthetics to create the perfect home',
  },
  {
    title: 'Office Interior',
    description:
      'Creating functional and inspiring work environments that enhance productivity while embodying a modern, professional style.',
  },
  {
    title: 'Restaurant Interior',
    description:
      'Crafting inviting and stylish dining spaces that provide a memorable experience, balancing ambiance with practicality.',
  },
  {
    title: 'Retail Interior',
    description:
      'Developing visually striking retail spaces that attract customers and enhance their shopping experience to next level.',
  },
  {
    title: 'Hotel Interior',
    description:
      'Designing inviting and elegant interiors for hotels, resorts, and lounges, ensuring a memorable guest experience.',
  },
  {
    title: 'Other Services',
    description:
      'Offering a range of customized interior solutions, including retail spaces, cafes, and more, tailored to your specific needs',
  },
]
export const Services = () => {
  return (
    <section className={`${pageXPadding} ${pageYPadding} `}>
      <div
        className={`${pageMaxWidth} mx-auto flex flex-col items-start gap-y-[24px]`}
      >
        <SectionTitle variant="secondary" title="Our Services Includes" />
        <div className="flex w-full flex-col gap-y-[24px] md:flex-row">
          <div className="flex w-full flex-col gap-y-[24px] md:w-1/2 md:flex-row-reverse">
            <div className="flex justify-center md:hidden">
              <ServiceImage />
            </div>
            <div className="flex w-full shrink-0 flex-col gap-y-[24px] ">
              {services.map(
                (service, index) =>
                  index < 4 && <Service key={index} {...service} />
              )}
            </div>
          </div>
          <div className="flex flex-col gap-y-[24px] md:w-1/2 md:flex-row md:flex-wrap">
            <div className="hidden md:block">
              <ServiceImage />
            </div>
            {services.map(
              (service, index) =>
                index > 3 && (
                  <div key={index} className="w-full">
                    <Service {...service} />
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

type ServiceProps = {
  title: string
  description: string
}
const ServiceImage = () => {
  return (
    <div className="relative   flex max-h-[357px] min-h-[180px] min-w-[281px] max-w-[557px] justify-center">
      <img src={ourServicesBg} className="relative z-10 size-full" />
      <img
        className="absolute right-0 top-0 z-0 h-[152.68px] w-[148.35px] -translate-y-1/2 translate-x-1/2  md:size-[200px] lg:size-[284px]"
        src={circularBorder}
      />
    </div>
  )
}
const Service = ({ title, description }: ServiceProps) => {
  return (
    <div className="flex w-full flex-col pl-[44px] pt-[12px] font-nunito text-[#000000]">
      <div className="relative">
        <h2 className="text-[16px] font-bold  leading-[19.2px]  md:text-[20px] md:leading-[24px] lg:text-[24px] lg:leading-[28.8px]">
          {title}
        </h2>
        <svg
          className="absolute  bottom-1/2 left-[-44px] h-[35px] w-[44px]"
          viewBox="-10 -10 120 120"
        >
          <polyline
            points="0 0,50 100,110 100"
            className="w-full fill-none stroke-[#8C1D40] stroke-[8px]"
          />
        </svg>
      </div>
      <p className="text-[12px] font-normal leading-[19.2px]  md:text-[14px] md:leading-[22.4px] lg:text-[16px]  lg:leading-[25.6px] ">
        {description}
      </p>
    </div>
  )
}
